import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
  DatePicker,
  TimePicker, Checkbox,
  Modal, Tooltip, List,
} from "antd";
import { withRouter } from "react-router";
import ReactQuill from 'react-quill';
import get from "lodash/get";
import { connect } from "react-redux";
import { Controlled as CodeMirror } from "react-codemirror2";
import SettingsConsentFormBuilderPreview from './SettingsConsentFormBuilderPreview';

import {
  updateConsentRequest,
  createConsentRequest,
  getSettingsSitesRequest, apiUrl, getCFschema,
  getAllLanguagesRequest,
} from "../../api/requests";
import {
  getConsentCreatePermission,
  getConsentUpdatePermission,
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";

import classes from "./SettingsConsentForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import moment from "moment-timezone";
import classnames from "classnames";

const routes = require("../../routes.json");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

const { Option } = Select;

class SettingsConsentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      content: null,
      source_template_content: null,
      sites: [],
      view: "html",
      isPreviewFormModal: false,
      isExampleFormModal: false,
      isPreviewEmailFormModal: false,
      isPreviewEmailFormInvestigatorModal: false,

      showExtraCssBlock: false,
      showEmailSignatureBlock: false,
      showOverrideCustomFormsBlock: false,
      showEmailExcludedFieldsBlock: false,
      showRequiredForPositiveFieldsBlock: false,
      showConsentFieldPropertiesBlock: false,
      fieldsCheckResult: {},
      allLanguages: [],
    };

    this.quillRef = React.createRef();
  }

  async componentDidMount() {
    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );
    this.getAllLanguages();

    this.setState({ content: this.props.content });
    this.setState({ source_template_content: this.props.source_template_content });
    this.setState({ extra_css: this.props.extra_css });
    this.editorInstance.setSize("100%", "500px");

    try {
      const { data } = await getSettingsSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }


  getAllLanguages = async () => {
    try {
      const { data } = await getAllLanguagesRequest();
      this.setState({
        allLanguages: data,
      });
    } catch (e) {
      console.log(e);
    }
  };

  handleSubmit = (e, stay) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });
      this.setState({ fieldsCheckResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const consent = { ...values };
          consent.content = this.state.content;
          consent.source_template_content = this.state.source_template_content;
          consent.extra_css = this.state.extra_css;

          if (values.consent_form_date_date && values.consent_form_date_time) {
            consent.consent_form_date = moment(
              `${values.consent_form_date_date.format(
                "YYYY-MM-DD"
              )}T${values.consent_form_date_time.format("HH:mm")}`
            )
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss");
          }

          delete consent.consent_form_date_date;
          delete consent.consent_form_date_time;

          if (this.props.id) {
            await updateConsentRequest(this.props.id, consent);
          } else {
            await createConsentRequest(consent);
          }

          window.scrollTo(0, document.body.scrollHeight);

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });
          if (!stay){
            setTimeout(() => {
              this.props.onSubmit(this.props.id);
              this.props.history.push(routes.admin.consentEditor);
            }, 1000);
          }


        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }

        try {
          const ConsentFieldsReviewUrl = `${apiUrl()}/admin/settings/consent_form/fields-review/${this.props.id}`;
          const fieldsReviewData = await getCFschema(ConsentFieldsReviewUrl);
          console.log("Fields Review Data:", get(fieldsReviewData, 'data'));
          if (fieldsReviewData && fieldsReviewData['status'] == 200){
            const data = get(fieldsReviewData, 'data');
            if (get(data, 'is_valid') ==  true){
              this.setState({
                fieldsCheckResult: {
                  type: "info",
                  message: "No field errors.",
                },
            });

            }else{
              const message = "Fields configured incorrectly: " + JSON.stringify(get(data, 'field_errors'), null, 2);
              this.setState({
                fieldsCheckResult: {
                  type: "warning",
                  message: message,
                },
            });
            }
          }
        } catch (e) {
          console.log("Could not load field errors: ", e);
        }

      }
    });
  };

  quillModules = {
    toolbar: {
      container: [
        [{ 'header': 1 }, { 'header': 2 }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    },
  };
  collapseSection = (sectionName) => () => {
    this.setState((state) => ({ [sectionName]: !state[sectionName] }));
  };


  render() {
    const { isLoading, requestResult, content, source_template_content, extra_css, sites, view,
      showExtraCssBlock,
      showEmailSignatureBlock,
      showOverrideCustomFormsBlock,
      showEmailExcludedFieldsBlock,
      showRequiredForPositiveFieldsBlock, showConsentFieldPropertiesBlock, fieldsCheckResult
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      consentUpdatePermission,
      consentCreatePermission,
      id,
      isNew,
    } = this.props;

    const isEditable = id ? consentUpdatePermission : consentCreatePermission;

    const appliedVal = getFieldValue("applied_to");
    const PdfExampleUrl = `${apiUrl()}/admin/settings/consent_form/pdf-cf-examples`;
    const CFExampleUrl = `${apiUrl()}/admin/settings/consent_form/cf-examples`;
    const PdfPreviewUrl = `${apiUrl()}/admin/settings/consent_form/pdf-preview/${this.props.id}`;
    const UiPreviewUrl = `${apiUrl()}/admin/settings/consent_form/ui-preview/${this.props.id}`;
    const FormPreviewUrl = `${apiUrl()}/admin/settings/consent_form/cf-preview/${this.props.id}`;
    const EmailFormsPreviewUrl = `${apiUrl()}/admin/settings/consent_form/email-cf-preview/${this.props.id}`;
    const EmailFormsInvestigatorPreviewUrl = `${apiUrl()}/admin/settings/consent_form/email-cf-preview/${this.props.id}?who_is_collecting_consent=investigator`;
    const ConsentFieldsReviewUrl = `${apiUrl()}/admin/settings/consent_form/fields-review/${this.props.id}`;


    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge
                  count={this.props.i18n.t("Edit")}
                  style={{ backgroundColor: "#2968AE" }}
                />
              </span>
            ) : isNew ? (
              this.props.i18n.t("NamespaceSettingsConsentForm:Add consent")
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>{this.props.i18n.t("Name")}:</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("name")} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col lg={6}>
              <label>
                <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Consent setting type")}:</b>
                <Form.Item>
                  {getFieldDecorator("consent_setting_type", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "consent_setting_type", ""),
                  })(
                    <Select>
                      {get(this.props.consentSettings, "consent_setting_type", []).map(
                        (item) => (
                          <Option key={item.id} value={item.value}>
                            {item.name}
                          </Option>
                        )
                      )}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col lg={6}>
              <label>
                <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Consent workflow type")}:</b>
                <Form.Item>
                  {getFieldDecorator("consent_workflow_type", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "consent_workflow_type", ""),
                  })(
                    <Select>
                      {get(this.props.consentSettings, "workflow_type", []).map(
                        (item) => (
                          <Option key={item.id} value={item.value}>
                            {item.name}
                          </Option>
                        )
                      )}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col lg={6}>
              <label>
                <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Template file type")}:</b>
                <Form.Item>
                  {getFieldDecorator("template_file_type", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "template_file_type", ""),
                  })(
                    <Select>
                      {get(this.props.consentSettings, "consent_template_file_type", []).map(
                        (item) => (
                          <Option key={item.id} value={item.value}>
                            {item.name}
                          </Option>
                        )
                      )}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          {(this.props.template_file_type == 'ui' || this.props.template_file_type == 'source') ? (
            // these properties will only be evaluated on the UI file type on the backend
            // eventually we will remove the filetype property altogether
            <div>
              <Row gutter={12}>
                <Col lg={6}>
                  <label>
                    <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Allow recording consent by email")}:</b>
                    <Form.Item>
                      {getFieldDecorator("allow_email_consent", {
                        rules: [{ required: false, message: this.props.i18n.t("Required") }],
                        initialValue: get(this.props, "allow_email_consent", false),
                        valuePropName: "checked",
                      })(
                        <Checkbox>
                        </Checkbox>
                      )}
                    </Form.Item>
                  </label>
                </Col>
              </Row>
              <Row gutter={12}>
                <Col lg={6}>
                  <label>
                    <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Allow recording consent by pdf upload")}:</b>
                    <Form.Item>
                      {getFieldDecorator("allow_paper_consent", {
                        rules: [{ required: false, message: this.props.i18n.t("Required") }],
                        initialValue: get(this.props, "allow_paper_consent", false),
                        valuePropName: "checked",
                      })(
                        <Checkbox>
                        </Checkbox>
                      )}
                    </Form.Item>
                  </label>
                </Col>
                <Col lg={6}>
                  <label>
                    <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Allow upload pdf later")}:</b>
                    <Form.Item>
                      {getFieldDecorator("allow_skipping_paper_upload", {
                        rules: [{ required: false, message: this.props.i18n.t("Required") }],
                        initialValue: get(this.props, "allow_skipping_paper_upload", false),
                        valuePropName: "checked",
                      })(
                        <Checkbox>
                        </Checkbox>
                      )}
                    </Form.Item>
                  </label>
                </Col>
              </Row>
            </div>
          ) : null}

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceSettingsConsentForm:Applied to")}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("applied_to", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "applied_to", ""),
                  })(
                    <Select>
                      <Option value="all_sites">
                        {this.props.i18n.t("All sites")}
                      </Option>
                      <Option value="site">{this.props.i18n.t("Site")}</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            {appliedVal === "site" && (
              <Col lg={12}>
                <label>
                  <b>{this.props.i18n.t("Site ID")}</b>
                  <Form.Item>
                    {getFieldDecorator("site_id", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "site_id"),
                    })(
                      <Select
                        placeholder={this.props.i18n.t("Select Site ID")}
                        style={{ width: "100%" }}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        {sites.map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
          </Row>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>{this.props.i18n.t("Language Code")}:</b>
                <Form.Item>
                  {getFieldDecorator("language_code", {
                    initialValue: get(this.props, "language_code", ""),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Select Language")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {this.state.allLanguages.map(({ code, name}) => (
                        <Option key={code} value={code}>
                          {code} - {name}
                        </Option>
                      ))}
                      <Option value="">
                        {this.props.i18n.t("None")}
                      </Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceSettingsConsentForm:Consent version"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("consent_version", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "consent_version", ""),
                  })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Version")} />)}
                </Form.Item>
              </label>
            </Col>

            <Col md={12}>
              <label>
                <b className={classes.labelText}>
                  {this.props.i18n.t(
                    "NamespaceSettingsConsentForm:Consent form date"
                  )}
                </b>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px",
                }}
              >
                <Form.Item>
                  <div style={{ width: "140px" }}>
                    {getFieldDecorator("consent_form_date_date", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "consent_form_date")
                        ? moment
                            .utc(this.props.consent_form_date)
                            .tz(
                              this.props.userTimezone ||
                                get(this.props, "site.time_zone") ||
                                "UTC"
                            )
                        : null,
                    })(
                      <DatePicker
                        disabled={!isEditable}
                        format="YYYY/MM/DD"
                        placeholder="yyyy-mm-dd"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;
                <Form.Item>
                  <div style={{ width: "120px" }}>
                    {getFieldDecorator("consent_form_date_time", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "consent_form_date")
                        ? moment
                            .utc(this.props.consent_form_date)
                            .tz(
                              this.props.userTimezone ||
                                get(this.props, "site.time_zone") ||
                                "UTC"
                            )
                        : null,
                    })(
                      <TimePicker
                        disabled={!isEditable}
                        format="HH:mm"
                        placeholder="HH:mm"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;&nbsp;
                <Form.Item>
                  {this.props.userShortTimezone ||
                    get(this.props, "site.time_zone") ||
                    "UTC"}
                </Form.Item>
              </div>
            </Col>
          </Row>


          {this.props.template_file_type != 'source' ? (
            // these properties will only be evaluated on the UI file type on the backend
            // eventually we will remove the filetype property altogether
            <div>
              <div className={classes.switchAction}>
                <button
                  className={classes.switchActionButton}
                  disabled={this.state.view === "html"}
                  type="button"
                  onClick={() => {
                    this.setState(() => ({
                      view: "html",
                    }));
                  }}
                >
                  {this.props.i18n.t("Code")}
                </button>
                &nbsp;
                <button
                  className={classes.switchActionButton}
                  disabled={this.state.view === "visualEditor"}
                  type="button"
                  onClick={() => {
                    this.setState(() => ({
                      view: "visualEditor",
                    }));
                  }}
                >
                  {this.props.i18n.t("Visual editor")}
                </button>
                &nbsp;
                <button
                  className={classes.switchActionButton}
                  disabled={this.state.view === "preview"}
                  type="button"
                  onClick={() => {
                    this.setState(() => ({
                      view: "preview",
                    }));
                  }}
                >
                  {this.props.i18n.t("Preview")}
                </button>
              </div>

              <Row
                gutter={12}
                style={{ display: view === "html" ? "block" : "none" }}
              >
                <Col>
                  <b>{this.props.i18n.t("Content")}:</b>
                  <div style={{ marginBottom: "20px" }}>
                    <CodeMirror
                      editorDidMount={(editor) => {
                        this.editorInstance = editor;
                      }}
                      value={content}
                      onBeforeChange={(editor, data, value) => {
                        this.setState({ content: value });
                      }}
                      options={{
                        mode: "html",
                        theme: "material",
                        lineNumbers: true,
                      }}
                    />
                  </div>
                </Col>
              </Row>
              { view === "visualEditor" && <Row
                  gutter={12}
                  style={{ display: view === "visualEditor" ? "block" : "none" }}
                >
                  <Col>
                    <b>{this.props.i18n.t("Content")}:</b>
                    <div style={{ marginBottom: "20px" }}>
                      <ReactQuill
                        value={content || ''}
                        onChange={(content) => {
                          // this.setState({ content });
                        }}
                        ref={this.quillRef}
                        readOnly={!isEditable}
                        theme="snow"
                        modules={this.quillModules}
                      />
                    </div>
                  </Col>
                </Row>}

               { view === "preview" &&  <Row
                  gutter={12}
                  style={{ display: view === "preview" ? "block" : "none" }}
                >
                  <Col>
                    <h3 className="headline-default">
                      {this.props.i18n.t("Preview")}
                    </h3>
                    <iframe
                      srcDoc={
                        content
                          ? content
                              .replace(/src="{{(.*)}}/g, 'src="{{$1}}" alt="$1"')
                              .replace(/src={{(.*)}}/g, 'src="{{$1}}" alt="$1"')
                              .replace(/margin-left: -15px/g, "")
                              .replace(
                                /static\/images/g,
                                "https://act-staging-api.dctms.ca/static/images"
                              )
                              .replace(
                                /url\(\"static/g,
                                'url("https://act-staging-api.dctms.ca/static'
                              )
                          : ""
                      }
                      className={classes.previewFrame}
                    />
                  </Col>
                </Row> }
                <div className={classes.switchAction}>
                  {(this.props.template_file_type == 'ui') ? (
                    <a className={classes.switchActionButton}
                     style={{marginRight: '10px'}}
                      href={UiPreviewUrl} target="_blank">
                      {this.props.i18n.t("Preview UI")}
                    </a>
                    ) : null}
                  {(this.props.template_file_type == 'pdf') ? (
                    <a className={classes.switchActionButton}
                     style={{marginRight: '10px'}}
                      href={PdfPreviewUrl} target="_blank">
                      {this.props.i18n.t("Preview PDF")}
                    </a>
                    ) : null}
              </div>
              <p><i>{this.props.i18n.t("NamespaceSettingsConsentForm:Preview gets updated AFTER SAVE")}</i></p>
            </div>
          ) :

          <div>

            <Row
                gutter={12}
              >
                <Col>
                  <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Source template content")}:</b>

                <div className={classes.switchAction} style={{float: 'right'}}>
                  <a className={classes.switchActionButton}
                     style={{marginRight: '10px', float: 'right'}}
                    href={PdfExampleUrl} target="_blank">
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Example PDF")}
                  </a>
                </div>

                  <div className={classes.switchAction} style={{float: 'right'}}>
                    <button className={classes.switchActionButton}
                            type="button" style={{marginRight: '10px'}} onClick={() => {
                      this.setState({isExampleFormModal: true})
                    }}>
                      {this.props.i18n.t("NamespaceSettingsConsentForm:Example Form Fields")}
                    </button>
                  </div>


                  <div style={{marginBottom: "35px"}}>
                    <CodeMirror
                      editorDidMount={(editor) => {
                        this.editorInstance = editor;
                      }}
                      value={source_template_content}
                      onBeforeChange={(editor, data, value) => {
                        this.setState({ source_template_content: value });
                      }}
                      options={{
                        indentWithTabs: false,
                        theme: "material",
                        mode: 'htmlmixed',
                        lineNumbers: true,
                        lineWrapping: true,
                        foldGutter: true,
                        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
                        autoCloseBrackets: true,
                        matchBrackets: true,
                        lint: true,
                      }}
                    />
                  </div>
                </Col>
              </Row>


                {(this.props.template_file_type == 'source') ? (
                  <div>
                    <br/>
                    {/* -------------- EXTRA CSS ------------*/}
                    <Row
                      gutter={8}  className={classes.collapsibleFormWrapper}
                    >
                    <Col>
                        <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(
                          "showExtraCssBlock"
                        )}
                      >
                        <Tooltip
                          title={
                            showExtraCssBlock
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t("show")
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showExtraCssBlock ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("NamespaceSettingsConsentForm:Extra CSS")}

                          <Badge
                            count={
                              !!extra_css
                                ? this.props.i18n.t("Set")
                                : this.props.i18n.t("Not set")
                            }
                            style={{
                              backgroundColor: !!extra_css
                                ? "rgba(73,200,80,0.44)"
                                : "#999",
                            }}
                          />

                        </span>
                      </h4>

                      <div className={classnames(
                        showExtraCssBlock ? classes.shown : classes.hidden,
                        classes.collapsibleFormInner
                      )}>

                          <div style={{ marginBottom: "15px" }}>
                            <CodeMirror
                              editorDidMount={(editor) => {
                                this.cssEditorInstance = editor;
                              }}
                              value={extra_css}
                              onBeforeChange={(editor, data, value) => {
                                this.setState({ extra_css: value });
                              }}
                              options={{
                                indentWithTabs: false,
                                theme: "material",
                                mode: 'htmlmixed',
                                lineNumbers: true,
                                lineWrapping: true,
                                foldGutter: true,
                                gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
                                autoCloseBrackets: true,
                                matchBrackets: true,
                                lint: true,
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>


                    {/* -------------- EMAIL SIGNATURE CONFIG ------------*/}

                    <Row gutter={12} className={classes.collapsibleFormWrapper}>
                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(
                          "showEmailSignatureBlock"
                        )}
                      >
                        <Tooltip
                          title={
                            showEmailSignatureBlock
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t("show")
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showEmailSignatureBlock ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("NamespaceSettingsConsentForm:Email signature config")}

                          <Badge
                            count={
                              !!get(this.props, "signatures_required_config", "")
                                ? this.props.i18n.t("Set")
                                : this.props.i18n.t("Not set")
                            }
                            style={{
                              backgroundColor: !!get(this.props, "signatures_required_config", "")
                                ? "rgba(73,200,80,0.44)"
                                : "#999",
                            }}
                          />

                        </span>
                      </h4>

                      <div className={classnames(
                        showEmailSignatureBlock ? classes.shown : classes.hidden,
                        classes.collapsibleFormInner
                      )}>
                          <Col lg={24}>
                            <label>
                              <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Email signature config")}:</b>
                              <Form.Item>
                                {getFieldDecorator("signatures_required_config", {
                                  rules: [{ required: false, message: this.props.i18n.t("Required") }],
                                  initialValue: get(this.props, "signatures_required_config", ""),
                                })(<Input disabled={!isEditable} placeholder="" />)}
                              </Form.Item>
                            </label>
                          </Col>

                          <Col lg={24}>
                            <p>{this.props.i18n.t('NamespaceSettingsConsentForm:Json array of objects describing the role of the signer and the signatures required from him. Must be the same as in the template. Will be requested in order set by config. Support wildcard fields via "*"')}</p>
                            <p>{this.props.i18n.t("Example")}: <i>{'[{"person_role": "consent_subject", "role_name": "", "fields": ["consent_option", "consent_question_*"],  "signatures": ["consent_subject", "subject_authorization"]}, {"person_role": "consent_investigator", "signatures": ["consent_investigator"]}]'}</i></p>
                            <p><i>{this.props.i18n.t('NamespaceSettingsConsentForm:If "subject first" is selected in site, subject person will be moved to the beginning of the list. "investigator first" will be the default as is set in config (even if its subject first).')}</i></p>
                            <p><i>{this.props.i18n.t('NamespaceSettingsConsentForm:Signatures mean a group of fields (signature, name, role, date). Ordering is done by field and signature orders, first all of the fields then the signatures. Reordering the fields can be dope by adding a suffix "___[index]"')}</i></p>
                            <p><i>{this.props.i18n.t('NamespaceSettingsConsentForm:Custom example in "Review fields" json')}</i></p>
                          </Col>
                        </div>
                    </Row>

                  {/*-------------- FIELDS REQUIRED FOR CONSENT TO BE POSITIVE ------------*/}


                    <Row gutter={12} className={classes.collapsibleFormWrapper}>

                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(
                          "showRequiredForPositiveFieldsBlock"
                        )}
                      >
                        <Tooltip
                          title={
                            showRequiredForPositiveFieldsBlock
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t("show")
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showRequiredForPositiveFieldsBlock ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("NamespaceSettingsConsentForm:Fields Required for POSITIVE consent")}

                          <Badge
                            count={
                              !!get(this.props, "consent_given_field_requirements", "")
                                ? "Set"
                                : "Not set"
                            }
                            style={{
                              backgroundColor: !!get(this.props, "consent_given_field_requirements", "")
                                ? "rgba(73,200,80,0.44)"
                                : "#999",
                            }}
                          />

                        </span>
                      </h4>

                      <div className={classnames(
                        showRequiredForPositiveFieldsBlock ? classes.shown : classes.hidden,
                        classes.collapsibleFormInner
                      )}>


                        <Col lg={24}>
                          <label>
                            <b>{this.props.i18n.t("Fields Required for POSITIVE consent")}:</b>
                            <Form.Item>
                              {getFieldDecorator("consent_given_field_requirements", {
                                rules: [{ required: false, message: this.props.i18n.t("Required") }],
                                initialValue: get(this.props, "consent_given_field_requirements", ""),
                              })(<Input disabled={!isEditable} placeholder="" />)}
                            </Form.Item>
                          </label>
                        </Col>

                        <Col lg={24}>
                          <p>{this.props.i18n.t('NamespaceSettingsConsentForm:Defaults to consent_option and rccf_option.')}</p>
                          <p>{this.props.i18n.t('NamespaceSettingsConsentForm:Once consent is fully signed, will set either consent_option or rccf_option.')}</p>
                          <p>{this.props.i18n.t('NamespaceSettingsConsentForm:If not used, these forms will be created automaticaly from the source templates.')}</p>
                          <p>{this.props.i18n.t('Example')} [str, str]: <i>{'["consent_subject_signature", "initials_signature"]'}</i></p>
                          <p>{this.props.i18n.t('Example')} [dict, dict]: <i>{'[{"fieldName":"consent_subject_signature","operator":"notEmpty"},{"fieldName":"consent_question_LAR_not_available","operator":"isTrue"}]'}</i></p>
                          <p><i>{this.props.i18n.t('NamespaceSettingsConsentForm:Custom example in "Review fields" json')}</i></p>
                        </Col>
                        </div>

                    </Row>

                    {/*-------------- CONSENT FIELD PROPERTIES ------------*/}

                    <Row gutter={12} className={classes.collapsibleFormWrapper}>

                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(
                          "showConsentFieldPropertiesBlock"
                        )}
                      >
                        <Tooltip
                          title={
                            showConsentFieldPropertiesBlock
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t("show")
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showConsentFieldPropertiesBlock ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("NamespaceSettingsConsentForm:Consent Field Properties (NOT REQUIRED)")}

                          <Badge
                            count={
                              !!get(this.props, "consent_field_properties", "")
                                ? "Set"
                                : "Not set"
                            }
                            style={{
                              backgroundColor: !!get(this.props, "consent_field_properties", "")
                                ? "rgba(73,200,80,0.44)"
                                : "#999",
                            }}
                          />

                        </span>
                      </h4>

                      <div className={classnames(
                        showConsentFieldPropertiesBlock ? classes.shown : classes.hidden,
                        classes.collapsibleFormInner
                      )}>
                        <Col lg={24}>
                          <label>
                            <b>{this.props.i18n.t("Consent Field Properties (label, meaning ...)")}:</b>
                            <Form.Item>
                              {getFieldDecorator("consent_field_properties", {
                                rules: [{ required: false, message: this.props.i18n.t("Required") }],
                                initialValue: get(this.props, "consent_field_properties", ""),
                              })(<Input disabled={!isEditable} placeholder="" />)}
                            </Form.Item>
                          </label>
                        </Col>

                        <Col lg={24}>
                          <p>{this.props.i18n.t('NamespaceSettingsConsentForm:Place to rename the default in the signature certificate, and other properties.')}</p>
                          <p>{this.props.i18n.t('Example')} [str, str]: <i>{'{"consent_subject_signature": {"label": "Subject signature", "meaning": "Subject approves this!"}}'}</i></p>
                        </Col>
                      </div>

                    </Row>


                    {/* -------------- CUSTOM FORM OVERRIDES ------------*/}

                    <Row gutter={12} className={classes.collapsibleFormWrapper}>
                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(
                          "showOverrideCustomFormsBlock"
                        )}
                      >
                        <Tooltip
                          title={
                            showOverrideCustomFormsBlock
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t("show")
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showOverrideCustomFormsBlock ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("NamespaceSettingsConsentForm:Custom form overrides (NOT REQUIRED)")}

                          <Badge
                            count={
                              !!get(this.props, "custom_form_overrides", "")
                                ? "Set"
                                : "Not set"
                            }
                            style={{
                              backgroundColor: !!get(this.props, "custom_form_overrides", "")
                                ? "rgba(73,200,80,0.44)"
                                : "#999",
                            }}
                          />
                        </span>
                      </h4>
                      <div className={classnames(
                        showOverrideCustomFormsBlock ? classes.shown : classes.hidden,
                        classes.collapsibleFormInner
                      )}>
                          <Col lg={24}>
                        <label>
                          <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Custom form overrides (NOT REQUIRED)")}:</b>
                            <Form.Item>
                              {getFieldDecorator("custom_form_overrides", {
                                rules: [{ required: false, message: this.props.i18n.t("Required") }],
                                initialValue: get(this.props, "custom_form_overrides", ""),
                              })(<Input disabled={!isEditable} placeholder="" />)}
                            </Form.Item>
                          </label>
                        </Col>
                        <Col lg={24}>
                          <p>{this.props.i18n.t('NamespaceSettingsConsentForm:Steps: "electronic__step3",  "email__step3" and all the email steps by person ("email__person__[person_role]") can be using slugs from precreated custom forms for more detailed control.')}</p>
                          <p>{this.props.i18n.t('NamespaceSettingsConsentForm:If not used, these forms will be created automaticaly from the source templates.')}</p>
                          <p>{this.props.i18n.t('Example')}: <i>{'{"electronic__step3":"site_002_electronic_ui_consent_form", "email__step3":"site_002_email_step_3", "email__person__consent_subject":"site_002_email_consent_patient_subject"}'}</i></p>
                        </Col>
                        </div>
                    </Row>

                     {/* -------------- EMAIL EXCLUDED FIELDS ------------*/}

                    <Row gutter={12} className={classes.collapsibleFormWrapper}>
                      <h4
                        className={classnames(
                          "headline-default",
                          classes.toggleHeadline
                        )}
                        onClick={this.collapseSection(
                          "showEmailExcludedFieldsBlock"
                        )}
                      >
                        <Tooltip
                          title={
                            showEmailExcludedFieldsBlock
                              ? this.props.i18n.t(
                                  "collapse"
                                )
                              : this.props.i18n.t("show")
                          }
                        >
                          <Icon
                            type="arrow-up"
                            className={classes.collapseIcon}
                            style={{
                              fontSize: "20px",
                              transform: `rotate(${
                                showEmailExcludedFieldsBlock ? "0" : "180deg"
                              })`,
                            }}
                          />{" "}
                          &nbsp;
                        </Tooltip>
                        <span className={classes.toggleText}>
                          {this.props.i18n.t("NamespaceSettingsConsentForm:Fields excluded from email (NOT REQUIRED)")}
                          <Badge
                            count={
                              !!get(this.props, "email_excluded_fields", "")
                                ? "Set"
                                : "Not set"
                            }
                            style={{
                              backgroundColor: !!get(this.props, "email_excluded_fields", "")
                                ? "rgba(73,200,80,0.44)"
                                : "#999",
                            }}
                          />

                        </span>
                      </h4>
                        <div className={classnames(
                          showEmailExcludedFieldsBlock ? classes.shown : classes.hidden,
                          classes.collapsibleFormInner
                        )}>
                          <Col lg={24}>
                            <label>
                              <b>{this.props.i18n.t("NamespaceSettingsConsentForm:Fields excluded from email (NOT REQUIRED)")}:</b>
                              <Form.Item>
                                {getFieldDecorator("email_excluded_fields", {
                                  rules: [{ required: false, message: this.props.i18n.t("Required") }],
                                  initialValue: get(this.props, "email_excluded_fields", ""),
                                })(<Input disabled={!isEditable} placeholder="" />)}
                              </Form.Item>
                            </label>
                          </Col>

                          <Col lg={24}>
                            <p>{this.props.i18n.t('NamespaceSettingsConsentForm:These fields will not be included into the email forms, unless they are important for the workflow.')}</p>
                            <p>{this.props.i18n.t('NamespaceSettingsConsentForm:If not used, these forms will be created automaticaly from the source templates.')}</p>
                            <p>{this.props.i18n.t('Example')}: <i>{'["consent_witness_full_name", "consent_witness_signature"]'}</i></p>
                          </Col>
                        </div>
                    </Row>

                  </div>
                ) : null}

              <div className={classes.switchAction}>
                  <a className={classes.switchActionButton}
                     style={{marginRight: '10px'}}
                    href={PdfPreviewUrl} target="_blank">
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Preview PDF")}
                  </a>
                  <a className={classes.switchActionButton}
                     style={{marginRight: '10px'}}
                    href={UiPreviewUrl} target="_blank">
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Preview UI")}
                  </a>
                  <button className={classes.switchActionButton}
                          type="button" style={{marginRight: '10px'}} onClick={() => { this.setState({ isPreviewFormModal: true }) }}>
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Preview Form")}
                  </button>
                  <button className={classes.switchActionButton}
                          type="button" style={{marginRight: '10px'}} onClick={() => { this.setState({ isPreviewEmailFormModal: true }) }}>
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Preview Email Form")}
                  </button>
                  <button className={classes.switchActionButton}
                          type="button" style={{marginRight: '10px'}} onClick={() => { this.setState({ isPreviewEmailFormInvestigatorModal: true }) }}>
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Preview Email Form (Investigator)")}
                  </button>
                  <button className={classes.switchActionButton}
                          type="button" style={{marginRight: '10px'}} onClick={() => { this.setState({ isPreviewReviewFieldsModal: true }) }}>
                    {this.props.i18n.t("NamespaceSettingsConsentForm:Review fields in the consent")}
                  </button>
              </div>
              <p><i>{this.props.i18n.t('NamespaceSettingsConsentForm:Preview gets updated AFTER SAVE')}</i></p>
          </div>}

          <Modal visible={this.state.isPreviewFormModal} onCancel={() => { this.setState({ isPreviewFormModal: false }) }} footer={null}>
            {this.state.isPreviewFormModal && <SettingsConsentFormBuilderPreview url={FormPreviewUrl} />}
          </Modal>

          <Modal visible={this.state.isPreviewEmailFormModal} onCancel={() => { this.setState({ isPreviewEmailFormModal: false }) }} footer={null}>
            {this.state.isPreviewEmailFormModal && <SettingsConsentFormBuilderPreview url={EmailFormsPreviewUrl} />}
          </Modal>

          <Modal visible={this.state.isPreviewEmailFormInvestigatorModal} onCancel={() => { this.setState({ isPreviewEmailFormInvestigatorModal: false }) }} footer={null}>
            {this.state.isPreviewEmailFormInvestigatorModal && <SettingsConsentFormBuilderPreview url={EmailFormsInvestigatorPreviewUrl} />}
          </Modal>


          <Modal visible={this.state.isPreviewReviewFieldsModal} onCancel={() => { this.setState({ isPreviewReviewFieldsModal: false }) }} footer={null} width={767}>
            {this.state.isPreviewReviewFieldsModal && <SettingsConsentFormBuilderPreview url={ConsentFieldsReviewUrl} isJsonRaw />}
          </Modal>

          <Modal visible={this.state.isExampleFormModal} onCancel={() => { this.setState({ isExampleFormModal: false }) }} footer={null}>
            {this.state.isExampleFormModal && <SettingsConsentFormBuilderPreview url={CFExampleUrl} />}
          </Modal>

          {fieldsCheckResult.type && (
            <Alert
              message={fieldsCheckResult.message}
              type={fieldsCheckResult.type}
              className={classes.submitResult}
            />
          )}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="button"
                  onClick={(e) => this.handleSubmit(e, true)}
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("NamespaceSettingsConsentForm:Save And Continue Editing")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            )}
            &nbsp; &nbsp;
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            )}
            &nbsp; &nbsp;
            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  consentCreatePermission: getConsentCreatePermission(state),
  consentUpdatePermission: getConsentUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "consent" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(SettingsConsentForm)))
);



// WEBPACK FOOTER //
// ./src/components/SettingsConsentForm/SettingsConsentForm.js